import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import AccordionSummaryCardWithNestedItems
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/SummaryCardPicker/AccordionSummaryCard/Content/AccordionSummaryCardWithNestedItems';

const Styleless = ({ className, ...props }) => <Box {...props} />;

const useStyles = buildUseStyles('OutcomeGroup', ((theme) => ({
  root: {},
  summaryCardMetaForm: {
    padding: 0,
  },
  groupSummaryCardMetaForm: {
    padding: theme.spacing(0, 0, 0, 7),
  },
})));

const OutcomeGroup = ({ className }) => {
  const classes = useStyles();
  const { resource } = useMetaLayoutContext();

  return (
    <Box className={classNames(classes.root, className)}>
      <MetaFormInline
        className={classes.summaryCardMetaForm}
        layout={AccordionSummaryCardWithNestedItems}
        noIndividualSubmitButtons
        component={Styleless}
        resource={resource}
      />
    </Box>
  );
};

OutcomeGroup.defaultProps = {
  className: '',
};

OutcomeGroup.propTypes = {
  className: PropTypes.string,
};

export default OutcomeGroup;
